<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { computed, onMounted, reactive } from 'vue'
import AccountKycProcessPersonal from '../verification/AccountKycProcessPersonal.vue'
import LoadingSpinner from '../../../base/LoadingSpinner.vue'

import AccountPanelPersonalMissingDataAlert from '../AccountPanelPersonalMissingDataAlert.vue'
import { IdentificationIcon, LocationMarkerIcon, ReceiptTaxIcon } from '@heroicons/vue/solid'

const state = usePersonalAccountDataState()

onMounted(() => {
    state.fetchKycDocuments()
})

const kycDocuments = reactive({
    kyc_id: {
        header: 'Identifikationsprüfung',
        icon: IdentificationIcon,
        accepted: computed(() => state.naturalProfile.kyc_id),
        documents: [],
    },
    kyc_tax: {
        header: 'Steuerpflichtigkeit',
        icon: ReceiptTaxIcon,
        accepted: computed(() => state.naturalProfile.kyc_tax),
        documents: [],
    },
    kyc_address: {
        header: 'Adressbestätigung',
        accepted: computed(() => state.naturalProfile.kyc_address),
        icon: LocationMarkerIcon,
        documents: [],
    },
})
</script>

<template>
    <AccountPanelPersonalMissingDataAlert
        v-if="!state.hasAllRequiredNaturalProfileAttributesForInvestment"
        inline
        :description-text="$t('verification.complete_data_description_for_verification')"
        class="my-9" />
    <AccountKycProcessPersonal
        v-else-if="!state.kycDocumentsLoading"
        class="px-6"
        profile-type="natural"
        :kyc-documents="kycDocuments" />
    <div v-else class="flex h-[10vh] items-center justify-center">
        <LoadingSpinner class="h-10 w-10 fill-primary" />
    </div>
</template>
